import { useMemo } from 'react';
import useSWR from 'swr';

// @ts-expect-error FIXME: TS7006 - strict mode migration
export const useItemEligibility = (item_code) => {
  const { data: itemDefinitionsData, error: itemDefinitionsError } = useSWR(
    '/v2/item_definitions'
  );

  return useMemo(() => {
    if (itemDefinitionsError) {
      return {
        loading: false,
        error: itemDefinitionsError,
      };
    }
    if (itemDefinitionsData) {
      return {
        loading: false,
        hasItemEligibility:
          // @ts-expect-error FIXME: TS7031 - strict mode migration
          itemDefinitionsData.filter(({ code }) => code === item_code).length >
          0,
      };
    }
    return { loading: true };
  }, [itemDefinitionsError, itemDefinitionsData]);
};
